import { Box, ButtonBase, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ExploreOutlined } from "@mui/icons-material";
import InfoBannerToggle from "./InfoBannerToggle";
import {MouseEventHandler} from "react";

interface InfoBannerHeaderProps {
  isExpanded: boolean;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
}

const InfoBannerHeaderTitle = styled(Typography)({
  fontSize: "0.9643rem",
  fontWeight: 700,
  color: "#1a2636",
});

// Hidden on phones to keep the collapsed banner to one compact row.
const InfoBannerHeaderSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: "0.8214rem",
  color: "#66727e",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const InfoBannerHeaderRoot = styled(ButtonBase)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  padding: "14px 20px",
  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
  },
  background: "linear-gradient(90deg, #f0f8ff 0%, #fff 100%)",
  borderBottom: "1px solid #e0e6ec",
  cursor: "pointer",
  userSelect: "none",
  textAlign: "left",
}));

const InfoBannerHeaderLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

/** Cyan rounded icon box displayed at the start of the header row. */
const InfoBannerHeaderIconBox = styled(Box)({
  width: "2.2857rem",      // 32px
  height: "2.2857rem",     // 32px
  borderRadius: "0.5714rem", // 8px
  backgroundColor: "#19C6F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  flexShrink: 0,
});

/** Flex column that stacks the title and subtitle. */
const InfoBannerHeaderTitleStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const InfoBannerHeader = ({ isExpanded, onClick }: InfoBannerHeaderProps) => {
  return (
    <InfoBannerHeaderRoot
      onClick={onClick}
      aria-expanded={isExpanded}
      aria-controls="info-banner-body"
      aria-label="Toggle getting started guide"
    >
      <InfoBannerHeaderLeft>
        <InfoBannerHeaderIconBox aria-hidden="true">
          <ExploreOutlined sx={{ fontSize: "1rem" }} />
        </InfoBannerHeaderIconBox>
        <InfoBannerHeaderTitleStack>
          <InfoBannerHeaderTitle variant="h5">
            Getting Started With Locations
          </InfoBannerHeaderTitle>
          <InfoBannerHeaderSubtitle marginTop="0.0714rem">
            Understand each location status and what actions are available
          </InfoBannerHeaderSubtitle>
        </InfoBannerHeaderTitleStack>
      </InfoBannerHeaderLeft>
      <InfoBannerToggle isExpanded={isExpanded} />
    </InfoBannerHeaderRoot>
  );
};

export default InfoBannerHeader;
